"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _StateFilterDropdown = _interopRequireDefault(require("./CampaignCreator/StateFilterDropdown"));

var _reactRedux = require("react-redux");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function StateFilter(props) {
  var selectedPersonasLength = props.selectedPersonasLength,
      loadingPop = props.loadingPop,
      population = props.population,
      hasDataFiltering = props.hasDataFiltering,
      universes = props.universes,
      currentUniverse = props.currentUniverse,
      isFetching = props.isFetching,
      setUniverse = props.setUniverse,
      fixedAudienceView = props.fixedAudienceView,
      displayStateFilter = props.displayStateFilter;

  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
    return {
      stateMessageText: state.audienceView.view.textPlural
    };
  }),
      stateMessageText = _useSelector.stateMessageText;

  var selectedMessageText = fixedAudienceView || stateMessageText;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "state-filter"
  }, props.children, /*#__PURE__*/_react["default"].createElement("div", {
    className: "state-filter__tally-container"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "state-filter__tally-message"
  }, "Selected ", selectedMessageText, ": ", selectedPersonasLength, ' '), /*#__PURE__*/_react["default"].createElement("span", null, "Population:", ' ', loadingPop ? /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Loader, {
    className: "state-filter-inline-loader",
    size: "tiny",
    inline: true,
    active: true
  }) : population.toLocaleString())), hasDataFiltering && displayStateFilter && /*#__PURE__*/_react["default"].createElement(_StateFilterDropdown["default"], {
    universes: universes,
    current: currentUniverse,
    setUniverse: setUniverse,
    isLoading: isFetching
  }));
}

var _default = StateFilter;
exports["default"] = _default;